import { styled } from '@mui/material/styles';
import { DatagridWithStickyActions } from 'shared/react-admin/Datagrids/DatagridWithStickyActions/DatagridWithStickyActions';

export const StyledDatagrid = styled(DatagridWithStickyActions)({
  '& th.MuiTableCell-paddingCheckbox': {
    paddingTop: '0 !important',
    verticalAlign: 'middle',
  },
  '& td.MuiTableCell-paddingCheckbox': {
    paddingTop: '0 !important',
    verticalAlign: 'middle',
  },
  '& .MuiTableCell-root': {
    verticalAlign: 'middle',
  },
  '& .column-amount': { minWidth: '172px', textAlign: 'right' },
  '& .column-provider': { minWidth: '165px' },
  '& .MuiTableCell-paddingCheckbox': {
    padding: '0 12px 0 16px',
  },
});
